const renewalApplications = [
    {
        "uuid": "1",
        "customerName": "源天然股份有限公司",
        "appNo": "A21100101",
        "assessmentPlace": "台東廠",
        "createdOn": "2021-10-01T08:00:00.000Z",
        "productionLineRemoves": [
            {
                "productionLine": "果汁線",
                "removes":[
                    {
                        "name": "Natural Benefits 食安生技-椰子汁",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "250ml/包",
                        "channel": ["leezen"],
                        "backEndName": "食安生技-椰子汁",
                        "status": "approve",
                    },
                    {
                        "name": "Natural Benefits 食安生技-椰子汁",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "360ml/包",
                        "channel": ["leezen"],
                        "backEndName": "食安生技-椰子汁",
                        "status": "improvement",
                    },
                    {
                        "name": "atural Benefits 純在葡萄柚蘋果綠茶",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "250ml/包",
                        "channel": ["leezen"],
                        "backEndName": "純在葡萄柚蘋果綠茶",
                        "status": "suspend",
                    },
                    {
                        "name": "atural Benefits 純在葡萄柚蘋果綠茶",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "360ml/包",
                        "channel": ["leezen"],
                        "backEndName": "純在葡萄柚蘋果綠茶",
                        "status": "approve",
                    },
                ]
            },
            {
                "productionLine": "飲料線",
                "removes":[
                    {
                        "name": "桂圓四物飲",
                        "tseyueLevel": "",
                        "leezenLevel": "organic",
                        "productionLine": "飲料線",
                        "processStatus": "backEnd",
                        "packaging": "glassBottle",
                        "spec": "360ml/瓶",
                        "channel": ["leezen", "family"],
                        "status": "approve",
                    },
                    {
                        "name": "桂圓四物飲",
                        "tseyueLevel": "",
                        "leezenLevel": "organic",
                        "productionLine": "飲料線",
                        "processStatus": "backEnd",
                        "packaging": "glassBottle",
                        "spec": "1000ml/瓶",
                        "channel": ["leezen", "family"],
                        "status": "approve",
                    },
                ]
            },
            {
                "productionLine": "餅乾線",
                "removes":[
                    {
                        "name": "杏仁玄米餅",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "餅乾線",
                        "processStatus": "backEnd",
                        "packaging": "paperBag",
                        "spec": "200/盒",
                        "channel": ["leezen"],
                        "status": "approve",
                    },
                ]
            },
        ],
        "productAttachmentOverdueList": [
            {
                "product": "杏仁玄米餅",
                "attachmentType": "productInspectionReport",
                "filenameOld": "檔案11.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "productInspectionReport",
                "filenameOld": "檔案12.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案21.pdf",
                "validDateOld": "2021-11-20T08:00:00.000Z",
                "dateType": "文件日期",
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "enterFoodPermissionNotice",
                "filenameOld": "檔案31.pdf",
                "validDateOld": "2021-09-30T08:00:00.000Z",
                "dateType": "報告日期",
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "alcoholContentTestReport",
                "filenameOld": "檔案41.pdf",
                "validDateOld": "2021-12-09T08:00:00.000Z",
                "dateType": "報告日期",
            },
            {
                "product": "桂圓四物飲",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案51.pdf",
                "validDateOld": "2021-12-05T08:00:00.000Z",
                "dateType": "文件日期",
            },
        ],
        "rawMaterialAttachmentOverdueList": [
            {
                "rawMaterial": "豆蓉粉",
                "product": "杏仁玄米餅",
                "attachmentType": "inspectionReport",
                "filenameOld": "檔案11.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "type":"material",
                "storageCondition":"roomTemperature",
                "composition":"",
                "domesticVendor":"穎昌食品有限公司(新和美)",
                "importer":"",
                "manufacturer":"穎昌食品有限公司(新和美)",
                "originPlace":"台灣",
                "additiveLicenseNumber":"",
                "addRatio":9,
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":1,
                "relatedDocuments":[
                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                ]
            },
            {
                "rawMaterial": "美國加州杏仁果",
                "product": "杏仁玄米餅、杏仁巧克力酥",
                "attachmentType": "foodAdditiveLicense",
                "filenameOld": "檔案12.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "有效日期",
                "type":"material",
                "storageCondition":"roomTemperature",
                "domesticVendor":"信成股份有限公司",
                "importer":"信成股份有限公司",
                "manufacturer":"TERRA NOVA TRADING INC.",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":2
            },
            {
                "rawMaterial": "有機生糙米粉(台灣)",
                "product": "杏仁巧克力酥",
                "attachmentType": "enterFoodPermissionNotice",
                "filenameOld": "檔案21.pdf",
                "validDateOld": "2021-11-20T08:00:00.000Z",
                "dateType": "進口日期",
                "storageCondition":"refrigeration",
                "domesticVendor":"青田農產有限公司",
                "importer":"",
                "manufacturer":"青田農產有限公司",
                "originPlace":"台灣",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":8
            },
            {
                "rawMaterial": "甜扁桃仁粒",
                "product": "杏仁玄米餅",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案31.pdf",
                "validDateOld": "2021-09-30T08:00:00.000Z",
                "dateType": "有效日期",
                "storageCondition":"refrigeration",
                "domesticVendor":"成久旺股份有限公司",
                "importer":"成久旺股份有限公司",
                "manufacturer":"TWIN COMMODITIES,INC.",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":6
            },
            {
                "rawMaterial": "杏仁粉(細)",
                "product": "杏仁玄米餅",
                "attachmentType": "organicCertificate",
                "filenameOld": "檔案41.pdf",
                "validDateOld": "2021-12-09T08:00:00.000Z",
                "dateType": "有效日期",
                "storageCondition":"roomTemperature",
                "domesticVendor":"成久旺股份有限公司",
                "importer":"成久旺股份有限公司",
                "manufacturer":"Treehouse California Almonds LLC",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":11
            },
        ]
    },
]

export default renewalApplications;